import React from "react";
import { useFormik } from "formik";
import { ChequeAddFormValidation } from "./ChequeAddFormValidation";
import ChequeAddFormFields from "./ChequeAddFormFields";
import { ErrorToast, SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { client } from "../../../service/ApolloClient/ApolloClient";
import errorValidationApollo from "../../../utility/Forms/errorValidationApollo";
import {
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";
import {
  MUTATION_ADD_CHEQUE,
  MUTATION_EDIT_CHEQUE,
} from "../../../service/ApolloClient/ApolloMutation";
import { withRouter } from "react-router";
import checkDateInput from "../../../utility/CheckDateInput/checkDateInput";
import {
  CHEQUE_SELECT_ATTACHMENT,
  CHEQUE_SELECT_REPEAT,
} from "../../../containers/Cheque/ChequeEditpage";
import ChequeAuditsList from "../../../containers/Cheque/ChequeAuditsList";
import { generateChequePdf } from "../../../utility/PdfGenerator/ChequePdfGenerator";
import PrintIcon from "@material-ui/icons/Print";

const validationSchema = ChequeAddFormValidation;

const ChequeAddForm = (props) => {
  let valueDefault = {
    cheque_id: "",
    chequeable_type: "",
    chequeable_id: "",
    chequeable_name: "",
    giver_user_id: "",
    giver_user_fullname: "",
    reciver_user_id: "",
    reciver_user_fullname: "",
    first_party_id: "",
    first_party_fullname: "",
    second_party_id: "",
    second_party_fullname: "",
    guarantor_id: "",
    guarantor_fullname: "",
    recommender_id: "",
    recommender_fullname: "",
    amount: null,
    bank: "",
    bank_branch: "",
    account: "",
    is_guarantee_cheque: false,
    due_date: null,
    delivered_date: null,
    returned_date: null,
    cashed_date: null,
    bounced_date: null,
    transfered_date: null,
    description: "",
    icis: "",
    recieverable_type: "",
    recieverable_id: "",
    recieverable_name: "",
    status: "",
  };

  if (props.isEdit || props.isRepeat) {
    valueDefault = {
      ...valueDefault,
      ...props.data,
      is_guarantee_cheque: props.data.is_guarantee_cheque == "1",
    };

    if (props.data.reciver_user_id) {
      valueDefault.recieverable_type = "user";
      valueDefault.recieverable_id = props.data.reciver_user_id;
    }
  }

  const formikData = useFormik({
    initialValues: valueDefault,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      let newValue = values;
      try {
        newValue.due_date = values.due_date
          ? checkDateInput(values.due_date)
          : null;
        newValue.delivered_date = values.delivered_date
          ? checkDateInput(values.delivered_date)
          : null;
        newValue.returned_date = values.returned_date
          ? checkDateInput(values.returned_date)
          : null;
        newValue.cashed_date = values.cashed_date
          ? checkDateInput(values.cashed_date)
          : null;
        newValue.bounced_date = values.bounced_date
          ? checkDateInput(values.bounced_date)
          : null;
        newValue.transfered_date = values.transfered_date
          ? checkDateInput(values.transfered_date)
          : null;
      } catch (e) {
        console.log(e);
      }

      submitHandle(values);
    },
  });

  const submitHandle = (values) => {
    values["amount"] = parseInt(values["amount"]);
    values["recieverable_id"] = values["recieverable_id"].toString();
    values["giver_user_id"] = parseInt(values["giver_user_id"]);
    values["first_party_id"] = parseInt(values["first_party_id"]);
    values["second_party_id"] = parseInt(values["second_party_id"]);
    setLoading(true);
    client
      .mutate({
        mutation: props.isEdit ? MUTATION_EDIT_CHEQUE : MUTATION_ADD_CHEQUE,
        variables: values,
      })
      .then((result) => {
        let cheque = props.isEdit
          ? result.data.editChequeMutation
          : result.data.addChequeMutation;

        if (cheque === null) {
          ErrorToast("لطفا موارد مشخص شده را اصلاح بفرمایید");
          formikData.setErrors(
            errorValidationApollo({ title: "قادر به ثبت نمی باشد" }),
          );
        } else {
          SuccessToast(
            props.isEdit ? "با موفقیت ویرایش شد" : "چک با موفقیت افزوده شد",
          );
        }
        setLoading(false);

        props.history.push("/cheque/edit/" + cheque.id);
      })
      .catch((reason) => {
        ErrorToast("مشکل در ثبت فرم");
        formikData.setErrors(errorValidationApollo(reason));
        setLoading(false);
      })
      .finally(() => {
        setAuditId(Math.random());
      });

    setLoading(true);
  };

  const [loading, setLoading] = React.useState(false);
  const [auditId, setAuditId] = React.useState(Math.random);

  // formikData.isSubmitting = false;
  return (
    <Box>
      <Card>
        <CardContent>
          <Box ml={2} mb={2} display={"flex"}>
            <Box flexGrow={1} ml={1}>
              <Typography variant={"h5"} align={"left"}>
                {props.isRepeat
                  ? "تکرار فرم چک " + props.data.cheque_id
                  : props.isEdit
                    ? "ویرایش چک" + props.data.id + "#"
                    : "  افزودن چک"}
              </Typography>
            </Box>
            <Box style={{ textAlign: "left", float: "right" }} display={"flex"}>
              {props.isEdit ? (
                <ButtonGroup style={{ float: "right" }}>
                  <Button
                    color={"primary"}
                    onClick={(e) =>
                      props.handleSelectPage(CHEQUE_SELECT_ATTACHMENT)
                    }
                  >
                    ضمیمه ها
                  </Button>
                  <Button
                    color={"secondary"}
                    onClick={(e) =>
                      props.handleSelectPage(CHEQUE_SELECT_REPEAT)
                    }
                  >
                    تکرار فرم
                  </Button>
                  <Button
                    color={"secondary"}
                    onClick={(e) =>
                      props.history.push(
                        "/cheque/history/" + props.data.cheque_id,
                      )
                    }
                  >
                    تاریخچه چک
                  </Button>
                  <Button
                    color={"default"}
                    startIcon={<PrintIcon />}
                    onClick={() => generateChequePdf(props.data)}
                  >
                    پرینت
                  </Button>
                </ButtonGroup>
              ) : null}
            </Box>
          </Box>
          <ChequeAddFormFields
            isEdit={props.isEdit}
            loading={loading}
            {...formikData}
          />
        </CardContent>
      </Card>
      {props.isEdit ? (
        <Box style={{ marginTop: 10 }} key={auditId}>
          <ChequeAuditsList chequeId={props.data.id} />
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
};

export default withRouter(ChequeAddForm);
